import ConfigManager from "@/config/ConfigManager.js";
import BzbsApi from "@/core/Http/BzbsApi.js";
import { map } from "rxjs/operators";

/**
 * @method apiGetLuckyDrawBlob
 */

export default {
    /**
     * Return luckydraw content
     */
    apiGetMenuLuckyDrawBlob: function() {
        var url = ConfigManager.getBlobUrl() + `/webconfig/${ConfigManager.getBlobConfigDev()}/luckydraw/luckydrawConfig.json`;
        return BzbsApi.connectBzbsGetBlob(url).pipe(map(res => res.data));
    },
};
